import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import {
  ApiResponseModel,
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
  Pagination,
  PagingResponseModel,
} from "../shared";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AutomatedPermissionWizardService extends BaseApiTemplateService<any> {
  constructor(http: HttpClient) {
    super();
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX + "permission-wizard";
    this.httpClient = http;
  }

// core2/tnt/dm/permission-wizard
//   "autoCreate" : "true" or "false",
// "permTmplGuid" : "",
// "appletGuid" : "",
// "companyGuids" : [],
// "locationGuids" : [],
// "branchGuids" : [],
// "rolePrefix" : "",
// "permSetPrefix" : ""

  generatePermissions(autoCreate: boolean, permTmplGuid: string,appletGuid: string,
     companyGuids: string[],locationGuids: string[], branchGuids: string[],rolePrefix: string,
     permSetPrefix: string, visa: ApiVisa): Observable<any> {

    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }

    const body = {
      autoCreate: autoCreate,
      permTmplGuid: permTmplGuid,
      applet_guid: appletGuid,
      companyGuids: companyGuids,
      locationGuids: locationGuids,
      branchGuids: branchGuids,
      rolePrefix: rolePrefix,
      permSetPrefix: permSetPrefix
    };
    // let header = this.getHttpHeader(visa);
    return this.httpClient.post<ApiResponseModel<any>>(this.apiUrl, body, this.getHttpHeader(visa));

    // return this.httpClient.get<any>(this.apiUrl,headers:header)
  }
}
